import { boxApply1qmzdb3dh90hg as boxApply } from '../js/coreRuntime.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function tryToComputeNext($this) {
  $this.state_1 = 3;
  $this.computeNext_o8do8q_k$();
  return $this.state_1 === 1;
}
var AbstractIteratorClass;
function AbstractIterator() {
  if (AbstractIteratorClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        this.state_1 = 0;
        this.nextValue_1 = null;
      }
      hasNext_bitz1p_k$() {
        var tmp;
        switch (this.state_1) {
          case 2:
            tmp = false;
            break;
          case 1:
            tmp = true;
            break;
          case 0:
            tmp = tryToComputeNext(this);
            break;
          default:
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('hasNext called when the iterator is in the FAILED state.');
        }
        return tmp;
      }
      next_20eer_k$() {
        if (this.state_1 === 1) {
          this.state_1 = 0;
          return this.nextValue_1;
        }
        if (this.state_1 === 2 || !tryToComputeNext(this)) {
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        }
        this.state_1 = 0;
        return this.nextValue_1;
      }
      setNext_vbbbu2_k$(value) {
        this.nextValue_1 = value;
        this.state_1 = 1;
      }
      done_wskjm6_k$() {
        this.state_1 = 2;
      }
    }
    initMetadataForClass($, 'AbstractIterator');
    AbstractIteratorClass = $;
  }
  return AbstractIteratorClass;
}
//region block: exports
export {
  AbstractIterator as AbstractIterator1svf7vpi1lw8y,
};
//endregion

//# sourceMappingURL=AbstractIterator.mjs.map
